import { defineAsyncComponent } from 'vue'

const EmailTemplatesSelect = defineAsyncComponent(() => import('./email-templates-select.vue'))
const EmailTemplate = defineAsyncComponent(() => import('./email-template.vue'))

export { EmailTemplate, EmailTemplatesSelect }
